/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_Center_Right_LabelInputs */



/**
* | output |
* | --- |
* | "Center Right" |
*
* @param {Style_Guide_Manager_Position_Center_Right_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_center_right_label = /** @type {((inputs?: Style_Guide_Manager_Position_Center_Right_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_Center_Right_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Centre droit")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitte rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Centro destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центристский правый")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("中右")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央右")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र दाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro-direita")
	return /** @type {LocalizedString} */ ("Center Right")
});